import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: space-between;

    .blank {
        margin-top: 20rem;
    }
    h1 {
        margin-bottom: 10rem;
        font-size: 80px;
        font-weight: 300;
        font-family: "Montserrat";
    }
`;

export const Footer = styled.div`
    display: flex;
    flex-direction: column;

    align-items: center;
    justify-content: center;

    width: 100%;
    max-width: 800px;

    margin-bottom: 3rem;

    .link-login {
        color: white;
        text-decoration: none;
        width: 100%;
        height: 100%;
        padding: 1.5rem 1rem;
    }

    .link-signup {
        color: #808080;
        text-decoration: none;
    }
`;

export const Button = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90%;
    border: none;
    color: white;
    font-family: Inter;
    font-weight: bold;
    font-size: large;
    background-color: black;
    border-radius: 10px;

    margin: 1rem;
`;
